import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignModeStep =
  () => import(/* webpackChunkName: "campaign-mode-step.async" */ './campaign-mode-step')
    .then(({ CampaignModeStepWithI18n }) => CampaignModeStepWithI18n);

const DelayedCampaignModeLazyRepository =
  () => import(/* webpackChunkName: "campaign-mode-step.async" */ './campaign-mode-lazy-repository')
    .then(({ CampaignModeLazyRepositoryWithI18n }) => CampaignModeLazyRepositoryWithI18n);

export const CampaignModeStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_MODE,
  view: DelayedCampaignModeStep,
  repository: DelayedCampaignModeLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
